<header class="site-header">
    <a class="brand-lockup" type="button" (click)="goLanding()" aria-label="Return to InMotion App Launcher landing">
        <img src="assets/inmotion-hosting-logo.png" alt="InMotion Hosting" />
    </a>

    <ng-container *ngIf="state.authenticated; else guestActions">
        <button class="logout-button" type="button" (click)="logout()">
            Logout
        </button>
    </ng-container>

    <ng-template #guestActions>
        <div class="header-actions">
            <nav *ngIf="state.step === 'landing'" class="top-nav" aria-label="Landing sections">
                <a *ngFor="let anchor of anchors" [href]="'#' + anchor.id"
                    (click)="$event.preventDefault(); scrollToAnchor(anchor.id)">{{ anchor.label }}</a>
            </nav>
            <button class="signin-button" type="button" (click)="signIn()">
                Sign In
            </button>
        </div>
    </ng-template>
</header>